package com.ijoin.data.model

sealed interface EventBookingResult {
    data class Reservation(val booking: Booking) : EventBookingResult
    data class TicketsIssued(val tickets: List<Ticket>) : EventBookingResult
}
